import { Component, OnDestroy, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.css']
})
export class FaqPageComponent implements OnInit, OnDestroy {

  faq: IFaqDto = null;
  loading = false;
  bannerTitle = '';
  private uiIdleSub: Subscription | undefined;

  constructor(
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private faqService: FaqService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.route.paramMap.subscribe((params: ParamMap) => {
      const code = params.get('code');
      this.loadFaq(code != null ? code : '');
    });
  }

  ngOnDestroy() {
    if (this.uiIdleSub) {
      this.uiIdleSub.unsubscribe();
      this.uiIdleSub = undefined;
    }
  }

  loadFaq(code: string) {
    if (!code) {
      this.bannerTitle = '';
      return;
    }

    this.loading = true;
    this.bannerTitle = '';
    this.faq = null;
    this.faqService.getFaqByCode(code).subscribe(result => {
      this.faq = result;
      this.bannerTitle = result && result.title ? result.title : code;
      this.cdr.detectChanges();
      this.scheduleLoadingDone();
    }, error => {
      console.error(error);
      this.faq = null;
      this.cdr.detectChanges();
      this.scheduleLoadingDone();
    });
  }

  /** Keep loading until Angular is idle and the browser has painted (accurate over fast). */
  private scheduleLoadingDone() {
    const self = this;
    if (this.uiIdleSub) {
      this.uiIdleSub.unsubscribe();
      this.uiIdleSub = undefined;
    }

    setTimeout(function () {
      self.uiIdleSub = self.ngZone.onStable.subscribe(function () {
        if (self.uiIdleSub) {
          self.uiIdleSub.unsubscribe();
          self.uiIdleSub = undefined;
        }

        var finish = function () {
          self.ngZone.run(function () {
            self.loading = false;
            self.sharedService.showLoadingMessage = false;
            self.cdr.detectChanges();
          });
        };

        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              setTimeout(finish, 100);
            });
          });
        } else {
          setTimeout(finish, 150);
        }
      });
    }, 0);
  }
}
